/*
 * AdDiCtO — transparent header scroll state.
 * Loaded by layout/theme.liquid only on pages where <body class="header-transparent">.
 *
 * Toggles `header-scrolled` on .header-wrapper once the sentinel placed right
 * after the header leaves the viewport. Uses IntersectionObserver (no scroll
 * listeners); the sentinel's height is kept equal to the header height so the
 * switch happens once the visitor has scrolled the header's own height.
 *
 * Note: the sentinel is an empty <div>. Dawn's base.css hides empty divs
 * (`div:empty { display: none }`); component-header-transparent.css forces it
 * back to display:block. A display:none target has no layout box and would make
 * the observer report "not intersecting" on its first callback.
 */
(function () {
  if (!('IntersectionObserver' in window)) return;

  var MIN_SENTINEL_HEIGHT = 64; // px — must match min-height in the CSS

  var intersectionObserver = null;
  var resizeObserver = null;

  function init() {
    var wrapper = document.querySelector('.section-header .header-wrapper');
    var sentinel = document.querySelector('.header-transparent__sentinel');
    if (!wrapper || !sentinel) return;

    if (intersectionObserver) intersectionObserver.disconnect();
    if (resizeObserver) resizeObserver.disconnect();

    // Threshold = header height, never below the minimum (so it can't be 0
    // even if the header measures 0 on first read).
    var syncThreshold = function () {
      var height = Math.max(wrapper.offsetHeight || 0, MIN_SENTINEL_HEIGHT);
      sentinel.style.height = height + 'px';
    };

    // Set synchronously BEFORE the observer is created so the first callback
    // sees a real box. The ResizeObserver only handles later changes.
    syncThreshold();

    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(syncThreshold);
      resizeObserver.observe(wrapper);
    }

    intersectionObserver = new IntersectionObserver(
      function (entries) {
        var entry = entries[entries.length - 1];

        // Guard: a target with no box (0 height) cannot be judged. Ignore the
        // callback rather than treating it as "scrolled past".
        if (!entry.boundingClientRect || entry.boundingClientRect.height === 0) return;

        wrapper.classList.toggle('header-scrolled', !entry.isIntersecting);
      },
      { threshold: 0 }
    );
    intersectionObserver.observe(sentinel);
  }

  init();

  // Theme editor re-renders the header section; re-bind to the new element.
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.classList.contains('section-header')) init();
  });
})();
